export default

    class GarageController {

    constructor(resource) {
        this._baseUrl = 'garage';
        this._resource = resource;
    }

    show() {
        return this._resource(this._baseUrl)
            .get()
            .then(res => res.json());
    }

    async availableGarages(vehicleType_id, client_id) {
        let response = await this._resource(`${this._baseUrl}/avaliable/${vehicleType_id}/client/${client_id}`).get()
        return response.json()
    }

    async getAllGarages() {
        let response = null
        try {
            response = await this._resource(`garages`).get()
            if (response.ok) {
                response.body.map((i) => {
                    i.address_street = i.address.street
                })
            }

            return response.body
        } catch (error) {
            console.log(error.message)
        }
//         return response.body
    }

    async create(garage) {
        let response = await this._resource('garage').save(garage)
        return {
            Ok: response.ok,
            message: response.body.message
        }
    }

    async update(garage) {
        let response = await this._resource(`garage/${garage.id}`).update(garage)
        return {
            Ok: response.ok,
            message: response.body.message
        }
    }

    async delete(garage) {
        let response = await this._resource(`garage/${garage.id}`).delete()
        return {
            Ok: response.ok,
            message: response.body.message
        }
    }

    async get(client_id) {
        let response = await this._resource(`garages/client/${client_id}`).get()
        return response.json()
    }

    async getPositionGarages() {
        let result = [];
        try {
            let response = await this._resource('garages/positions').get()
            if (response.ok) {
                let markers = response.body.map((i) => ({
                    position: {
                        lat: i.address.latitude,
                        lng: i.address.longitude
                    },
                    icon: "/static/img/garage-icon4.png"
                }));
                result = markers
            }

        } catch (error) {
            result = {
                ok: false,
                message: error
            }
        }
        return result
    }
}

